import React from 'react';

import Accent from './accent';
import type { ButtonProps } from './button';

export default function Cancel({ label = 'Cancel', ...props }: ButtonProps) {
  return <Accent label={label} plain {...props} />;
}
